import { DialogProps } from '@highmobility/console-ui-components';

import { ProjectInstance } from '@/types';

import { CertificateSnippetDialog } from './CertificateSnippetDialog';

export type MQTTCertificateSnippetDialogProps = {
  isOpen: DialogProps['isOpen'];
  setIsOpen: DialogProps['setIsOpen'];
  instance: ProjectInstance;
  certificateId: string;
  appId: string;
};

export function MQTTCertificateSnippetDialog(props: MQTTCertificateSnippetDialogProps) {
  const hostName =
    props.instance === 'production' ? 'mqtt.high-mobility.com' : 'sandbox.mqtt.high-mobility.com';

  const snippet = `mosquitto_sub --disable-clean-session -h ${hostName} -p 8883 -q 1 \\
--cafile ca_certificates.pem \\
--cert certificate.pem.crt \\
--key private.pem.key  \\
-t '${props.instance === 'production' ? `live/level13/${props.appId}/#` : `sandbox/level13/${props.appId}/#`}' \\
-i '${props.certificateId}'`;

  return (
    <CertificateSnippetDialog isOpen={props.isOpen} setIsOpen={props.setIsOpen} snippet={snippet} />
  );
}
